<template>
  <div class="main">
    <div class="photo" v-for="(img, idx) in imgs" :key="idx">
      <img :src="img" />
      <div class="preview">
        <i class="el-icon-view" @click="preview(idx)"></i>
        <!-- <i class="el-icon-delete" @click="remove(idx)"></i> -->
      </div>
    </div>
    <div class="photo pick" @click="openImagePicker">
      <i class="el-icon-check"></i>
    </div>
    <image-preview ref="imagePreview"></image-preview>
    <image-picker ref="imagePicker" v-model="value"></image-picker>
  </div>
</template>

<script>

export default {
  props: {
    value: [String, Object, Array],
    images: [String, Object, Array]
  },
  watch: {
    value: {
      handler() {
        this.$emit("input", this.value); //更新value
      }
    },
  },
  computed: {
    imgs() {
      if (this.$utils.isValid(this.value)) return this.value.split(',').map(url => this.baseUrl + url)
      return [];
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_API,
      index: 0
    }
  },
  methods: {
    openImagePicker() {
      this.$refs.imagePicker.open(this.images);
    },
    preview(idx) {
      this.$refs.imagePreview.open(this.imgs, idx);
    },
    //删除图片
    remove(idx) {
      const arr = this.value.split(',');
      arr.splice(idx, 1);
      this.$emit('input', arr.join(','));
    }
  }
}
</script>
<style scoped lang="scss">
.main {
  display: flex;
  flex-direction: row;
}

.preview {
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;

  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;

  color: white;
  font-size: 24px;
  border-radius: 6px;
}

/* 鼠标移入 .photo 时显示遮罩 */
.photo:hover .preview {
  opacity: 1;
  cursor: pointer;
}

.photo {
  position: relative;
  /* 让 preview 绝对定位的参考容器 */
  overflow: hidden;
  /* 遮罩不超出图片范围 */

  width: 146px;
  height: 146px;
  margin-right: 10px;
  border-radius: 6px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.photo img {
  width: 146px;
  height: 146px;
  border-radius: 6px;
  object-fit: cover;
}

.pick {
  background-color: #fbfdff;
  border: 1px dashed gray
}

.pick:hover {
  border: 1px dashed #409EFF;
  cursor: pointer;
}

.el-icon-check {
  color: gray;
  font-size: 28px;
}

//忽略作用域限制，把这个样式穿透作用到 .el-dialog__body 上
::v-deep .el-dialog__body {
  padding: 0 !important;
  margin: 0 !important;
}

::v-deep .el-dialog__header {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
